import { Body1, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import styles from './Statistics.css';
import { userProfileStatisticsSelector } from '../../../../../selectors/userProfile';
import { AboutTabSection } from '../AboutTabSection';

export const Statistics = () => {
  const statistic = useSelector(userProfileStatisticsSelector);

  if (!statistic?.parameters.length) {
    return null;
  }

  const { title, parameters } = statistic;

  return (
    <AboutTabSection title={title} testId="Statistics">
      <div className={styles['parameters']}>
        {parameters.map((parameter, index) => (
          <div className={styles['parameter']} key={`statistic_parameter_${index}`}>
            <Body1 color="text-secondary-default">{parameter.title}</Body1>

            <UIHeading2>{parameter.value}</UIHeading2>
          </div>
        ))}
      </div>
    </AboutTabSection>
  );
};
